import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '@/assets/icons/Logout.svg'


export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", {
    class: "logout",
    onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.logoutUser && _ctx.logoutUser(...args)))
  }, [
    _cache[1] || (_cache[1] = _createElementVNode("img", {
      src: _imports_0,
      alt: ""
    }, null, -1)),
    _createElementVNode("p", null, _toDisplayString(_ctx.$t('logout')), 1)
  ]))
}